import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`contexts.trace`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Recommended`}</em>{`. A Transaction has to have a specific `}<inlineCode parentName="dd">{`contexts.trace`}</inlineCode>{` entry that contains tracing information. See the `}<a parentName="dd" {...{
            "href": "/sdk/event-payloads/contexts/#trace-context"
          }}>{`Trace Context documentation`}</a>{`.`}</dd></dl></p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"contexts"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"trace"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"op"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"navigation"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"description"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"User clicked on <Link />"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"trace_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"743ad8bbfdd84e99bc38b4729e2864de"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"a0cfbde2bdff3adc"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"status"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"ok"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"parent_span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"99659d76b7cdae94"`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      